import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgBullseyeArrow(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/jsx("path", {
        className: "bullseye-arrow_svg__fillPath",
        d: "M12 2A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10c0-1.16-.21-2.31-.61-3.39l-1.6 1.6c.14.59.21 1.19.21 1.79a8 8 0 01-8 8 8 8 0 01-8-8 8 8 0 018-8c.6 0 1.2.07 1.79.21L15.4 2.6C14.31 2.21 13.16 2 12 2m7 0l-4 4v1.5l-2.55 2.55C12.3 10 12.15 10 12 10a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2c0-.15 0-.3-.05-.45L16.5 9H18l4-4h-3V2m-7 4a6 6 0 00-6 6 6 6 0 006 6 6 6 0 006-6h-2a4 4 0 01-4 4 4 4 0 01-4-4 4 4 0 014-4V6z"
      })
    })
  }));
}

export { SvgBullseyeArrow as default };
